import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { StaticDataService } from '../../services/static-data.service';
import { EnumService } from '../../services/enum.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-body-map-custom-question',
  templateUrl: './body-map-custom-question.component.html',
  styleUrls: ['./body-map-custom-question.component.scss']
})
export class BodyMapCustomQuestionComponent implements OnInit, AfterViewInit {
  @Input() form: UntypedFormGroup;
@Input() inputName: string;
@Input() questionIsRequired: boolean;
@Input() preValue: any; // relaunch answer: comma-separated bodyPartIDs string, or false
@ViewChild('bodySvg') bodySvg: ElementRef;

  EnumService = EnumService;
  bodyParts = [...StaticDataService.bodyParts];
  currentBodyPartIndex = 0;
  selectedBodyParts: { [key: number]: any } = {};
  isWebApp = UtilService.isWebApp();
  window = window;

  ngOnInit() {
    if (this.questionIsRequired && this.form && this.inputName) {
      const formGroup = this.form.get(this.inputName) as UntypedFormGroup;
      if (formGroup) {
        formGroup.setValidators(this.atLeastOneBodyPartSelectedValidator);
        formGroup.updateValueAndValidity();
      }
    }
  }

 

  ngAfterViewInit() {
    setTimeout(() => {
      this.restoreFromRelaunch();
      this.restoreFromSavedState();
    }, 500);
  }

private getPartElement(id: number): HTMLElement | null {
  if (!this.bodySvg) return null;
  return this.bodySvg.nativeElement.querySelector(`[id="${id}"]`);
}

  private findBodyPart(partId: number): any {
    let found: any = null;
    this.bodyParts.forEach((group) => {
      group.parts.forEach((part: any) => {
        if (part.id === partId) {
          found = part;
        }
      });
    });
    return found;
  }

  restoreFromRelaunch() {
    if (!this.preValue || !this.form || !this.inputName) return;

    const formGroup = this.form.get(this.inputName) as UntypedFormGroup;
    if (!formGroup) return;

    const affectedIds = String(this.preValue)
      .split(',')
      .map((value) => Number(value.trim()))
      .filter((value) => !isNaN(value));

    affectedIds.forEach((partId) => {
      const subControlName = UtilService.SubFCName(this.inputName, partId);
      const control = formGroup.get(subControlName);
      if (control) {
        control.setValue(true);
      }

      const part = this.findBodyPart(partId);
      if (part) {
        this.selectedBodyParts[partId] = { ...part, checked: true };
        const element = this.getPartElement(partId);
        if (element) {
          element.style.fill = '#E74731';
        }
      }
    });
  }

  restoreFromSavedState() {
    if (!this.form || !this.inputName) return;

    const formGroup = this.form.get(this.inputName) as UntypedFormGroup;
    if (!formGroup) return;

    // Iterate all body parts and check if sub control exists and is true
    this.bodyParts.forEach((group) => {
      group.parts.forEach((part: any) => {
        const subControlName = UtilService.SubFCName(this.inputName, part.id);
        const control = formGroup.get(subControlName);
        if (control && control.value === true) {
          this.selectedBodyParts[part.id] = { ...part, checked: true };
          const element = this.getPartElement(part.id);
          if (element) {
            element.style.fill = '#E74731';
          }
        }
      });
    });
  }

  saveToForm(partId: number, checked: boolean) {
    if (!this.form || !this.inputName) return;

    const formGroup = this.form.get(this.inputName) as UntypedFormGroup;
    if (!formGroup) return;

    const subControlName = UtilService.SubFCName(this.inputName, partId);
    const control = formGroup.get(subControlName);
    if (control) {
      control.setValue(checked);
    }
  }

  previousPart() {
    if (this.currentBodyPartIndex > 0) {
      this.currentBodyPartIndex--;
    }
  }

  nextPart() {
    if (this.currentBodyPartIndex < this.bodyParts.length - 1) {
      this.currentBodyPartIndex++;
    }
  }

  pathSelect(type: number) {
    let selectedItem: any;
    this.bodyParts.forEach((item) => {
      item.parts.forEach((subItem: any) => {
        if (subItem.id === type) {
          selectedItem = subItem;
        }
      });
    });

    if (selectedItem) {
      const checked = this.selectedBodyParts[type]?.checked ? false : true;
      this.selectedBodyParts[type] = { ...selectedItem, checked };
      const element = this.getPartElement(selectedItem.id);
      if (element) {
        element.style.fill = checked ? '#E74731' : selectedItem.path.fill;
      }
      this.saveToForm(type, checked);
    }
  }

  partSelectChange(item: any, event: any) {
    this.selectedBodyParts[item.id] = { ...item, checked: event.detail.checked };
    const element = this.getPartElement(item.id);
    if (element) {
      element.style.fill = event.detail.checked ? '#E74731' : item.path.fill;
    }
    this.saveToForm(item.id, event.detail.checked);
  }

  removeSelectedBodyPart(item: any) {
    this.selectedBodyParts[item.id] = { ...item, checked: false };
    const element = this.getPartElement(item.id);
    if (element) {
      element.style.fill = item.path.fill;
    }
    this.saveToForm(item.id, false);
  }


   atLeastOneBodyPartSelectedValidator = (group: AbstractControl): ValidationErrors | null => {
    const controls = (group as UntypedFormGroup).controls;
    const hasSelection = Object.keys(controls).some(
      (key) => controls[key].value === true
    );
    return hasSelection ? null : { required: true };
  };
}